import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { MutationKey } from '@shared/config';
import { vacancyApi } from '../vacancyApi';
import {
  type UpdateVacanciesTemplateRequest,
  type DetailVacanciesTemplate,
} from '../types';
import type { AxiosError } from 'axios';
import type { TFormErrorResponse } from '@shared/types';

export const useUpdateVacancyTemplate = (
  id: number
): UseMutationResult<
  DetailVacanciesTemplate,
  AxiosError<TFormErrorResponse>,
  UpdateVacanciesTemplateRequest
> => {
  return useMutation({
    mutationKey: [MutationKey.UPDATE_VACANCY_TEMPLATE, id],
    mutationFn: (data: UpdateVacanciesTemplateRequest) =>
      vacancyApi.updateVacanciesTemplate(id, data),
  });
};
